#!/usr/bin/env node
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */

import { PublicKey } from "@saberhq/solana-contrib";
import { Command } from "commander";
import { printTable } from "console-table-printer";
import { exit } from "process";

import * as pack from "../package.json";
import { PositionWrapper } from "../src/wrappers/positionWrapper";
import { makeSDK, printObjectTable } from "./utils";

export const program = new Command().name("crema-swap");
program.version(pack.version);

// Get the CremaSwap's swap pair info
program
  .command("info")
  .description("Get CremaSwap's swap pair information")
  .argument("<swapKey>", "The CremaSwap's swap acocunt key")
  .option("-c --config [config]", "Output the swap pair config")
  .action((swapKey: string, arg: any) => {
    const key = new PublicKey(swapKey);
    fetchCremaSwap(key, arg.config)
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        exit(0);
      });
  });

// Get the CremaSwap's swap pair info
program
  .command("list")
  .description("Get CremaSwap's swap pair list information")
  .action(() => {
    console.log(new Date().toString());
    const keys = [
      new PublicKey("8J3avAjuRfL2CYFKKDwhhceiRoajhrHv9kN5nUiEnuBG"),
      new PublicKey("FESPUeMZLHPGqQvpyJe2QCbNmqCtYPEr1fw2oUDGJN9Z"),
      new PublicKey("B1eNrQEExnPPmVbM3jiEAd89nW7tXUiArrk81JtUz6H8"),
      new PublicKey("C52SfQELE8kAUES36fAfBcvCkoWLgHTrANqMdFXqEnm8"),
      new PublicKey("QNZScPBQzskAPvYVipVeUBSkGVQ4vrkXyowcibXdi7V"),
      new PublicKey("GL2LxzsNLkttgaD46dQjSWycQSmf252TAPfK4tTuqjg7"),
    ];
    fetchCremaSwaps(keys)
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        console.log(new Date().toString());
        exit(0);
      });
  });

// Get the swap position information
program
  .command("position-info")
  .description("Get CremaSwap's position information")
  .requiredOption("-p --swap-key <swapKey>", "The CremaSwap's swap pair key")
  .argument("<nftMint>", "The position's nft mint account key")
  .action((nftMint: string, arg: any) => {
    const p = new PublicKey(arg.swapKey);
    const m = new PublicKey(nftMint);
    fetchSwapPosition(p, m)
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        exit(0);
      });
  });

// Get swap positions
program
  .command("positions")
  .description("Get CremaSwap's position list")
  .requiredOption("-p --swap-Key <swapKey>", "The CremaSwap's swap pair key")
  .option("-o --owner [owner]", "The owner of CremaSwap's positions")
  .action((arg) => {
    const p = new PublicKey(arg.swapKey);
    if (arg.owner === undefined) {
      fetchSwapPositions(p)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          exit(0);
        });
    } else {
      if (arg.owner === true) {
        fetchSwapPositionsByOwner(p, null)
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            exit(0);
          });
      } else {
        const o = new PublicKey(arg.owner);
        fetchSwapPositionsByOwner(p, o)
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            exit(0);
          });
      }
    }
  });

async function fetchCremaSwap(swapKey: PublicKey, config = false) {
  const sdk = makeSDK();
  const swap = await PositionWrapper.fetchCremaSwap(
    swapKey,
    sdk.provider.connection
  );
  if (swap === null) {
    console.log("CremaSwap %s not foundl", swapKey.toString());
    return;
  }
  const data = {
    ...swap,
    currentPrice: swap.currentSqrtPrice.pow(2),
  };
  printObjectTable(data);
  if (config) {
    const pair = {
      name: "",
      fee: swap.fee.toString(),
      swap_account: swap.tokenSwapKey.toBase58(),
      token_a: {
        symbol: "",
        token_mint: swap.tokenAMint.toBase58(),
        swap_token_account: swap.swapTokenA.toBase58(),
        decimal: 6,
      },
      token_b: {
        symbol: "",
        token_mint: swap.tokenBMint.toBase58(),
        swap_token_account: swap.swapTokenB.toBase58(),
        decimal: 6,
      },
      price_interval: {
        lower_price: "1",
        upper_price: "1",
      },
    };
    console.log(JSON.stringify(pair, null, 2));
  }
}

export async function fetchSwapPositions(swapKey: PublicKey) {
  const sdk = makeSDK();
  const positions = await PositionWrapper.fetchSwapPositions(
    swapKey,
    sdk.provider.connection
  );
  if (positions.length > 0) {
    printTable(positions);
  } else {
    console.log("No position in this swap:%s", swapKey.toBase58());
  }
}

export async function fetchSwapPositionsByOwner(
  swapKey: PublicKey,
  authority: PublicKey | null
) {
  const sdk = makeSDK();
  const owner = authority !== null ? authority : sdk.provider.wallet.publicKey;
  const positions = await PositionWrapper.fetchSwapPositionsByOwner(
    swapKey,
    owner,
    sdk.provider.connection
  );

  if (positions.length > 0) {
    printTable(positions);
  } else {
    console.log("The position owner of %s not found", owner.toBase58());
  }
}

async function fetchSwapPosition(swapKey: PublicKey, nftMint: PublicKey) {
  const sdk = makeSDK();
  const positionInfo = await PositionWrapper.fetchSwapPositionByNFT(
    swapKey,
    nftMint,
    sdk.provider.connection
  );
  if (positionInfo === null) {
    console.log(
      "The swap position nft:%s not found in swap:%s",
      nftMint.toBase58(),
      swapKey.toBase58()
    );
    return;
  }
  printObjectTable(positionInfo);
}

async function fetchCremaSwaps(swapList: PublicKey[]) {
  const sdk = makeSDK();
  const list = await PositionWrapper.fetchCremaSwaps(
    swapList,
    sdk.provider.connection
  );
  for (let i = 0; i < swapList.length; i++) {
    const swap = list[i];
    if (swap === null || swap === undefined) {
      console.log("CremaSwap %s not foundl", swapList[i]?.toBase58());
      return;
    }
    const data = {
      ...swap,
      currentPrice: swap.currentSqrtPrice.pow(2),
    };
    printObjectTable(data);
  }
}
